var defaults = require('object-defaults')
var nodeType = require('./node-type')
var type = require('component-type')

/**
 * Expose `stringify`.
 */
const debug = false;
const noop = () => {};
const error = !debug ? noop : console.error
const log = !debug ? noop : console.log
const warn = !debug ? noop : console.warn


function validateHtml (string) {
  const element = document.createElement('div');
  element.innerHTML = string;
  const newString = element.innerHTML;

  if (newString != string) {
    warn(`HTML not valid: ${string}, will use correct ${newString}`);
  }

  return newString;
}

function stringifyInstance (instance, componentId) {
  const entities = instance.entities;
  const rootEntititiesByPath = instance && instance.children.root;
  const rootEntityId = rootEntititiesByPath && rootEntititiesByPath[0];
  const entity = instance.entities[componentId || rootEntityId];

  function stringifyEntity (path, entity) {
    const parentChildEntities = Object.fromEntries(Object.entries(instance.children[entity.id]).map(([path, childEntityId]) => {
      return [path, entities[childEntityId]];
    }));
    const childEntityAtThisParentPath = parentChildEntities[path];

    return stringifyNode(childEntityAtThisParentPath.virtualElement, '0', childEntityAtThisParentPath);
  }

  const isIgnoredIfEmpty = node => ['div', 'script'].includes(node.type);
  const isIgnoredNodeType = node => ['style'].includes(node.type);

  function stringifyNode (node, path, entity) {
    switch (nodeType(node)) {
      case 'empty': return;
      case 'text': {
        const trimmed = ('' + node).trim();

        return trimmed && document.createTextNode(trimmed.trim());
      }
      case 'element':
        const element = document.createElement(node.type);
        const {innerHTML, ...realAttributes} = node.attributes;

        Object.entries(realAttributes).map(([key, value]) => {
          if (!value || !isValidAttributeValue(value) || typeof value === 'function') {
            return;
          }

          if (key.startsWith('data-') || key === 'key' || key === 'style' || key === 'class') {
            return;
          }

          element.setAttribute(key, value);
        });

        if (innerHTML) {
          element.innerHTML = innerHTML;
        } else {
          node.children.map((child, index) => stringifyNode(child, path + '.' + index, entity)).filter(Boolean).map(childElement => {
            if (isIgnoredIfEmpty(node) && childElement.childNodes.length === 0) {
              return;
            }

            if (isIgnoredNodeType(node)) {
              return;
            }

            element.appendChild(childElement);
          });
        }

        if (isIgnoredIfEmpty(node) && element.childNodes.length === 0) {
          return;
        }

        return element;
      case 'component': {
        return stringifyEntity(path, entity)
      }
    }

    throw new Error('Invalid type')
  }

  const node = stringifyNode(entity.virtualElement, '0', entity);

  return node.innerHTML;
}

function stringifyApp (app) {
  function stringify (component, optProps, children) {
    var propTypes = component.propTypes || {}
    var props = defaults(optProps || {}, component.defaultProps || {})
    var state = component.initialState ? component.initialState(props) : {}
    props.children = children

    for (var name in propTypes) {
      var options = propTypes[name]
      if (options.source) {
        props[name] = app.sources[options.source]
      }
    }

    if (component.beforeMount) component.beforeMount({ props: props, state: state })
    if (component.beforeRender) component.beforeRender({ props: props, state: state })
    var node = component.render({ props: props, state: state })
    return stringifyNode(node, '0')
  }

  function stringifyNode (node, path) {
    switch (nodeType(node)) {
      case 'empty': return '<noscript />'
      case 'text': return node
      case 'element':
        var children = node.children
        var attributes = node.attributes
        var tagName = node.type
        var innerHTML = attributes.innerHTML
        var str = '<' + tagName + attrs(attributes) + '>'

        if (innerHTML) {
          str += innerHTML
        } else {
          for (var i = 0, n = children.length; i < n; i++) {
            str += stringifyNode(children[i], path + '.' + i)
          }
        }

        str += '</' + tagName + '>'
        return str
      case 'component': return stringify(node.type, node.attributes, node.children)
    }

    throw new Error('Invalid type')
  }

  return stringifyNode(app.element, '0')
}

module.exports = function (appOrInstance, componentId) {
  const instance = appOrInstance.inspect && appOrInstance.inspect();
  const app = instance ? instance.app : appOrInstance;

  if (!app.element && !instance) {
    throw new Error('No app element mounted or no instance');
  }

  if (instance) {
    return stringifyInstance(instance, componentId);
  }

  return stringifyApp(app);
}

const selfClosingTags = ['hr', 'img', 'input'];

/**
 * HTML attributes to string.
 *
 * @param {Object} attributes
 * @return {String}
 * @api private
 */

function attrs (attributes) {
  var str = ''
  for (var key in attributes) {
    var value = attributes[key]
    if (key === 'innerHTML') continue
    if (isValidAttributeValue(value)) str += attr(key, attributes[key])
  }
  return str
}

/**
 * HTML attribute to string.
 *
 * @param {String} key
 * @param {String} val
 * @return {String}
 * @api private
 */

function myEscape(s) {
  return ('' + s) /* Forces the conversion to string. */
      .replace(/\\/g, '\\\\') /* This MUST be the 1st replacement. */
      .replace(/\t/g, '\\t') /* These 2 replacements protect whitespaces. */
      .replace(/\n/g, '\\n')
      .replace(/\u00A0/g, '\\u00A0') /* Useful but not absolutely necessary. */
      .replace(/&/g, '\\x26') /* These 5 replacements protect from HTML/XML. */
      .replace(/'/g, '\\x27')
      .replace(/"/g, '\\x22')
      .replace(/</g, '\\x3C')
      .replace(/>/g, '\\x3E');
}

function attr (key, val) {
  return val !== '' ? ' ' + key + '="' + myEscape(val) + '"' : ''
}

/**
 * Is a value able to be set a an attribute value?
 *
 * @param {Any} value
 *
 * @return {Boolean}
 */

function isValidAttributeValue (value) {
  var valueType = type(value)
  switch (valueType) {
    case 'string':
    case 'number':
      return true

    case 'boolean':
      return value

    default:
      return false
  }
}
